import { render, staticRenderFns } from "./AdminProductSelectorsScreen.vue?vue&type=template&id=01147420&scoped=true&"
import script from "./AdminProductSelectorsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductSelectorsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01147420",
  null
  
)

export default component.exports